// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ft-z","tooltipWrapper":"gt-z","icon":"ht-z","tooltip":"it-z","content":"jt-z"};